const queryKeys = {
  getConfig: "queryKey_getConfig"
}

export default queryKeys